import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_r3cuwn57s4: FaireBrandEntity = {
  token: "b_r3cuwn57s4",
  type: "brand",
  name: "The Blue Yogi",
  avatarUrl:
    "https://cdn.faire.com/fastly/223804351b23ba1bc34f8694dfe694bd8249d3b7d1f8c4087ef3daa88419d4e0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/496ca75716c5bd9b2a2082a9bec485732e7e76a3bff3825f5e0fa24e0dd935d5.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/223804351b23ba1bc34f8694dfe694bd8249d3b7d1f8c4087ef3daa88419d4e0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/496ca75716c5bd9b2a2082a9bec485732e7e76a3bff3825f5e0fa24e0dd935d5.jpeg",
  location: "Pittsburgh, PA, USA",
  minimumOrderDollars: 192,
  rating: 5,
  reviewCount: 16,
  isTopShop: true,
  isInsider: true,
  description:
    "Welcome to The Blue Yogi, where the mysteries of nature are shaped and crafted into bespoke pieces that radiate positivity and calm. Feel the healing power of the Earth’s elemental treasures come to life and return to the moment with our range of beautiful jewelry and accessories.\nAt The Blue Yogi, we’ve chosen to create products that help people to spread positivity and love while adding a touch of classic beauty to their everyday lives. We work with love, our passion rooted in the mysterious energies of gemstones and the unique properties that benefit us.\nEach product has been carefully crafted to help people live consciously and in the present, with each piece thoughtfully designed and created to bring light and wellness into our valued clients’ lives.\nFrom delicate crystal bracelets, stunning gemstone necklaces, and simple healing bands to lovely gifts and accessories at The Blue Yogi, we’re constantly evolving our products, in step with the gentle shifting of life and the Earth.\nWe love our planet, and at The Blue Yogi, we believe in sustainability. That is why we ensure that our materials are sourced only from eco-friendly suppliers and that nothing goes to waste.\nFeel free to browse our curated selections and enjoy our extensive range of different gemstones and stunning jewelry. Don’t forget to enjoy our authentic tea selections along with our lovely gifts and accessories.\nWelcome to the Blue Yogi.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:55.217Z",
    importedBy: "entity-db-cli",
  },
};
